import { render, staticRenderFns } from "./SchoolOverviewPage.vue?vue&type=template&id=77b35054&scoped=true"
import script from "./SchoolOverviewPage.vue?vue&type=script&lang=js"
export * from "./SchoolOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./SchoolOverviewPage.vue?vue&type=style&index=0&id=77b35054&prod&scoped=true&lang=css"
import style1 from "./SchoolOverviewPage.vue?vue&type=style&index=1&id=77b35054&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b35054",
  null
  
)

export default component.exports